import RecordsTableCard from "./RecordsTableCard";

const LegalEntitiesWithoutTomWidget = ({ data = [], t, isFetching }) => {
  const rows = (data || []).map((item) => ({
    id: item.id,
    title: item.title,
  }));

  return (
    <RecordsTableCard
      t={t}
      title={t("Legal Entities Without TOM")}
      tooltipText={t("These legal entities are not included in any TOM.")}
      data={rows}
      type="plain"
      isFetching={isFetching}
    />
  );
};

export default LegalEntitiesWithoutTomWidget;
